<template>
  <div class="qa-page">
    <div class="qa-container">

      <!-- 뒤로가기 -->
      <button @click="handListBtn" class="qa-back">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        목록
      </button>

      <!-- 등록 카드 -->
      <div class="qa-card">
        <div class="qa-card-top">
          <div class="qa-badge">Q</div>
          <h1 class="qa-card-title">새 질문 작성</h1>
        </div>

        <hr class="qa-divider" />

        <form @submit.prevent="addQA" class="qa-form">

          <!-- 작성자 -->
          <div class="qa-field">
            <label class="qa-label">작성자</label>
            <div class="qa-readonly">{{ form.author }}</div>
          </div>

          <!-- 제목 -->
          <div class="qa-field">
            <label class="qa-label">제목 <span class="qa-required">*</span></label>
            <input
              v-model="form.title"
              type="text"
              placeholder="질문 제목을 입력하세요"
              class="qa-input"
              :class="{ 'qa-input--error': errors.title }"
            />
            <p v-if="errors.title" class="qa-error">{{ errors.title }}</p>
          </div>

          <!-- 내용 -->
          <div class="qa-field">
            <label class="qa-label">내용 <span class="qa-required">*</span></label>
            <textarea
              v-model="form.content"
              rows="10"
              placeholder="질문 내용을 상세히 작성해주세요"
              class="qa-input qa-input--textarea"
              :class="{ 'qa-input--error': errors.content }"
            ></textarea>
            <p v-if="errors.content" class="qa-error">{{ errors.content }}</p>
          </div>

          <!-- 버튼 -->
          <div class="qa-actions">
            <button type="button" class="qa-btn qa-btn--cancel" @click="handListBtn">취소</button>
            <button type="submit" class="qa-btn qa-btn--submit">등록</button>
          </div>

        </form>
      </div>

    </div>
  </div>
</template>

<script setup>
import { reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();

const user = computed(() => store.state.auth.user);

const form = reactive({
  title: '',
  author: `${user.value.name}`,
  content: '',
});

const errors = reactive({
  title: '',
  content: '',
});

const validateForm = () => {
  errors.title = form.title.trim() ? '' : '제목을 입력해주세요.';
  errors.content = form.content.trim() ? '' : '내용을 입력해주세요.';
  return !errors.title && !errors.content;
};

const addQA = async () => {
  if (!validateForm()) return;

  try {
    await store.dispatch('qaBoard/createQaList', {
      title: form.title,
      content: form.content,
      user_nm: form.author
    });
    store.commit('handleNotify', { message: 'Q&A가 성공적으로 등록되었습니다.', type: 'success' });
    await router.push({ name: 'QAPub' });
  } catch (error) {
    store.commit('handleNotify', { message: 'Q&A 등록에 실패하였습니다.' });
  }
};

const handListBtn = async () => {
  await router.push({ name: 'QAPub' });
};
</script>

<style scoped>
.qa-page {
  min-height: calc(100vh - 57px);
  background: #f5f5f7;
  padding: 32px 20px 60px;
}
.qa-container {
  max-width: 740px;
  margin: 0 auto;
}

/* 뒤로가기 */
.qa-back {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #888;
  margin-bottom: 20px;
  transition: color 0.15s;
}
.qa-back:hover { color: #333; }

/* 카드 */
.qa-card {
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.02);
}
.qa-card-top {
  display: flex;
  align-items: center;
  gap: 14px;
}
.qa-card-title {
  font-size: 20px;
  font-weight: 700;
  color: #111;
}

/* 뱃지 */
.qa-badge {
  width: 32px; height: 32px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 800;
  background: #4f46e5;
  color: #fff;
  flex-shrink: 0;
  letter-spacing: -0.5px;
}

.qa-divider {
  border: none;
  border-top: 1px solid #f0f0f0;
  margin: 24px 0;
}

/* 폼 */
.qa-form {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.qa-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.qa-label {
  font-size: 13px;
  font-weight: 600;
  color: #444;
}
.qa-required {
  color: #ef4444;
  margin-left: 2px;
}
.qa-readonly {
  padding: 12px 16px;
  font-size: 14px;
  color: #666;
  background: #f9f9f9;
  border: 1.5px solid #eee;
  border-radius: 12px;
}
.qa-input {
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  background: #fafafa;
  border: 1.5px solid #e8e8e8;
  border-radius: 12px;
  outline: none;
  transition: border-color 0.15s, background 0.15s;
}
.qa-input:focus {
  border-color: #7c3aed;
  background: #fff;
}
.qa-input::placeholder { color: #bbb; }
.qa-input--textarea {
  resize: vertical;
  min-height: 180px;
  line-height: 1.7;
}
.qa-input--error {
  border-color: #ef4444;
}
.qa-error {
  font-size: 12px;
  color: #ef4444;
}

/* 버튼 */
.qa-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
}
.qa-btn {
  padding: 10px 28px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 10px;
  transition: all 0.15s;
}
.qa-btn--cancel {
  background: #f3f4f6;
  color: #666;
}
.qa-btn--cancel:hover { background: #e5e7eb; }
.qa-btn--submit {
  background: #111;
  color: #fff;
}
.qa-btn--submit:hover { background: #333; }
</style>
